module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-11-e2f3f9d777e798b81ee69de5c69eea9a.jpg";